import React from 'react';
import BackButton from '../components/BackButton';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

const Terms = () => {
  return (
    <>
      <main className="flex-grow w-full max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop pb-12 md:pb-16 pt-28 md:pt-32">
        <BackButton />
        <Reveal>
        <div className="max-w-3xl mx-auto">
          <header className="mb-12 text-center">
            <h1 className="font-display-lg text-display-lg-mobile md:text-[40px] text-primary mb-4">Terms of Service</h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant">Please read these terms carefully before using our services.</p>
          </header>
          
          <div className="bg-surface-container-lowest rounded-2xl p-8 md:p-12 border border-outline-variant/30 shadow-[0_8px_30px_rgba(0,0,0,0.04)] space-y-8">
            <section>
              <h2 className="font-headline-md text-headline-md text-on-surface mb-4 flex items-center gap-2">
                <span className="material-symbols-outlined text-primary">gavel</span>
                Service Agreement
              </h2>
              <p className="text-on-surface-variant font-body-md leading-relaxed mb-4">
                By booking a service with TankCare, you agree to provide accurate information regarding your tank size, location, and accessibility. We reserve the right to modify or cancel services if the conditions differ significantly from what was initially reported.
              </p>
              <p className="text-on-surface-variant font-body-md leading-relaxed">
                Payments must be completed in full upon completion of the service. We guarantee the quality of our cleaning, but we are not liable for pre-existing structural damage to your water storage systems.
              </p>
            </section>
          </div>
        </div>
        </Reveal>
      </main>
      
      {/* Footer */}
      <Footer />
    </>
  );
};

export default Terms;
